import React from 'react';
import Wrapper from './AdminLTE/Wrapper';
import { useOutlet } from 'react-router-dom';
export default function Authenticated() {
    const outlet = useOutlet();
    return (
        <Wrapper page_content={outlet} />
    );
}
